export { Routes } from "./routes.component";
